import { ExerciseTag, IExercise } from "@hulanbv/platformapp";

import { IHttpOptions } from "nest-utilities-client";
import { FC } from "react";
import { generatePath, useHistory } from "react-router";
import { style } from "typestyle";
import { Header } from "../elements/header.element";
import { PageBody } from "../elements/page-body.element";
import { Page } from "../elements/page.element";
import { dictionary } from "../../state/common/constants/dictionary.constants";
import { Table } from "../elements/table.element";
import { exerciseService } from "../../state/exercise/exercise.service";
import { ExerciseRowTemplate } from "../templates/table-rows/exercise-row.template";
import { routes } from "../../state/common/constants/routes.constants";

const defaultHttpOptions: IHttpOptions<IExercise> = {
  match: {
    tags: ExerciseTag.BOOK,
  },
};

export const BookContentScreen: FC = () => {
  const history = useHistory();
  return (
    <Page>
      <PageBody fullWidth>
        <Header className={styles.centerHeader}>
          {dictionary.literals.books}
        </Header>
        <Table<IExercise>
          service={exerciseService}
          options={defaultHttpOptions}
          rowTemplate={(exercise) => (
            <ExerciseRowTemplate
              exercise={exercise}
              onViewClick={() =>
                history.push(
                  generatePath(routes.exercise.path, {
                    exerciseId: exercise._id,
                  }),
                )
              }
            />
          )}
        />
      </PageBody>
    </Page>
  );
};

const styles = {
  centerHeader: style({
    display: "flex",
    justifyContent: "center",
    paddingBottom: 20,
  }),
};
